import request from "../utils/request";

export function getAreaOption(level?: number, areaCode?: number) {
    return request.get('/com/areaOption', {params: {level, areaCode}});
}

export async function getProductPicture(model: string) {
    if (!model) {
        return []
    }
    const response = await request.get('/com/product/album', {params: {model}});
    return response.data.data
}

